export default () => {
  document.querySelectorAll('[data-accordion-toggle]').forEach((element) => {
    element.addEventListener('click', toggleAccordion);
    element.addEventListener('keyup', toggleAccordion);
  });

  // Initially open any active accordions
  document.querySelectorAll('[data-accordion-active]').forEach((element) => {
    const accordionContent = element.querySelector('[data-accordion-expands]');
    if (accordionContent) {
      accordionContent.style.height = accordionContent.scrollHeight + 'px';
    }
  });
};

function toggleAccordion(event) {
  const accordionTarget = event.currentTarget;
  const accordionParent = accordionTarget.parentNode;
  const accordionContent = accordionTarget.nextElementSibling;

  document.querySelectorAll('[data-accordion-active]').forEach((item) => {
    const content = item.querySelector('[data-accordion-expands]');
    if (content) {
      content.style.height = 0;
      item.removeAttribute('data-accordion-active');
    }
  });

  if (accordionParent.hasAttribute('data-accordion-active')) {
    accordionParent.removeAttribute('data-accordion-active');
    accordionContent.style.height = 0;
  } else {
    accordionParent.setAttribute('data-accordion-active', true);
    accordionContent.style.height = accordionContent.scrollHeight + 'px';
  }
}
